export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";